import { type AnchorHTMLAttributes } from "react";
import { NavLink } from "react-router";

type MenuLinkPropsType = {
  url: string;
  name: string;
  target?: string;
  className?: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export default function MenuLink({ url, name, target, className, ...props }: MenuLinkPropsType) {
  return url ? (
    target === "_blank" ? (
      <a href={url} {...{ className, target, ...props }}>
        {name}
      </a>
    ) : (
      <NavLink to={url} {...{ className, ...props }} viewTransition>
        {name}
      </NavLink>
    )
  ) : (
    <span {...{ className, ...props }}>{name}</span>
  );
}
